export const fuelInputs = [
  'machineId',
  'name',
  'location',
  'description',
  'startDate',
  'endDate',
  //   'breakdownDetails',
]

export const addFuelTaskInitialState = {
  machineId: null,
  name: null,
  startDate: null,
  endDate: null,
  location: null,
  description: null,
  trips: [],
  breakdownType: null,
  breakdownStartDate: null,
  breakdownEndDate: null,
  breakdownDetails: null,
}

export const fuelTypes = [
  { value: 1, label: 'Diesel' },
  { value: 2, label: 'Benzine' },
  { value: 3, label: 'Gas' },
]

export const fuelDeliveryRequestStatuses = [
  { value: 1, label: 'Requested' },
  { value: 2, label: 'In Procurement' },
  { value: 3, label: 'Partially Received' },
  { value: 4, label: 'Received' },
  { value: 5, label: 'Partially Fulfilled' },
  { value: 6, label: 'Fulfilled' },
  { value: 7, label: 'Cancelled' },
]

export const fuelDeliveryRequestStatusLabel = (status: number) =>
  fuelDeliveryRequestStatuses.find((s) => s.value === status)?.label || String(status)

export const fuelDeliveryFuelTypeLabel = (fuelType: number) =>
  fuelTypes.find((t) => t.value === fuelType)?.label || String(fuelType)


export const fuelConsumptionPeriods = [
  { value: 1, label: '12 Months' },
  { value: 2, label: '30 Days' },
  { value: 3, label: '7 Days' },
  { value: 4, label: '24 hours' },
]

export const fuelAlertRiskLevels = ['None', 'Low', 'Medium', 'High']

export const fuelAlertPriorities = ['Low', 'Medium', 'High', 'Critical']
